import React from "react"
import autobind from "class-autobind"
import { FontIcon, IconButton } from "material-ui"
import { IExpenseDocument, ELoggedInUserType, IUserDocument, ITimecardEmployee, ITimecardPriorPeriodData, IPayrollPayGroupData, IPayrollPayCalendar } from "../../../models"
import { grey200, grey500 } from "material-ui/styles/colors"
import AddUserDetailExpenseDialog from "../../../components/expense/AddUserDetailExpenseDialog"
import moment from "moment"
import AppStateStore from "../../../stores/AppStateStore"
import strings from "../../../localization/strings"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as colorHelper from "../../../helpers/colorHelper"
import ExternalLink from "../../common/externalLink/ExternalLink"
import * as expenseActions from "../../../actions/ExpenseActions"
import * as userHelper from "../../../helpers/userHelper"

interface IProps {
    timecardExpense: IExpenseDocument
    readonly: boolean
    user: ITimecardEmployee
    payrollDataForPayGroup: IPayrollPayGroupData | IPayrollPayCalendar
    payrollHierarchyId: string
    payrollPayGroupId: string
    reloadTimecard(msg: string): void

    // we need it when TimeExpenses case
    timecardPriorPeriodData?: ITimecardPriorPeriodData
}
interface IState {
    openAddExpenseDialog: boolean
    showRemoveEditIcons: boolean
}

export default class EmployeeTimecardExpensesValuesColumn extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddExpenseDialog: false,
            showRemoveEditIcons: false,
        }
        autobind(this)
    }

    render() {
        if (!userHelper.checkLoggedInUserPermission(this.props.user)) return null

        const isTimeExpense = this.props.timecardExpense.IsTime
        const canEditExpense = this.props.timecardExpense.PriorPeriodData ? permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.PriorPeriodAdjustmentsExportEdits) : true
        return (
            <div style={{ marginTop: 10 }} className="TextOverflow">
                <div
                    style={{ color: grey200 }}
                    onMouseOver={() => this.setState({ showRemoveEditIcons: true })}
                    onMouseOut={() => this.setState({ showRemoveEditIcons: false })}
                >
                    <IconButton
                        iconStyle={{ fontSize: 13, padding: 0 }}
                        style={{ padding: 0, width: 14, height: 14, marginRight: 3 }}
                        onTouchTap={() => this.setState({ openAddExpenseDialog: true })}
                    >
                        <FontIcon className="fa fa-info-circle ExpenseInfoIcon" />
                    </IconButton>
                    {this.props.timecardExpense.IsTime ? `${this.props.timecardExpense.Amount} hours` : `$${this.props.timecardExpense.Amount}`}
                    {!this.props.readonly && canEditExpense && permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.DeleteEmployeeExpense) &&
                        <i
                            key="remove"
                            className="fa fa-remove"
                            onClick={() => userHelper.checkLoggedInUserPermission(this.props.user) &&
                                AppStateStore.setConfirmDialogContent({
                                    title: strings.Delete_Expense,
                                    content: strings.Are_you_sure_you_want_to_delete_this_expense,
                                    confirm: () => expenseActions.deleteExpense(this.props.user, [this.props.timecardExpense.Id], this.props.reloadTimecard)
                                })}
                            style={{
                                width: 15, marginLeft: 5, color: "#aaaaaa", cursor: "pointer",
                                opacity: this.state.showRemoveEditIcons ? 1 : 0
                            }}
                        />
                    }
                </div>
                <div style={{ color: colorHelper.getExpenseTextLightColor(this.props.timecardPriorPeriodData) }}>
                    <FontIcon className="fa fa-tag" style={{ fontSize: 15, color: isTimeExpense && colorHelper.getExpenseTextLightColor(this.props.timecardPriorPeriodData), marginRight: 3 }} />
                    {this.props.timecardExpense.Name}
                </div>
                {this.props.timecardExpense.PriorPeriodData && this.props.timecardExpense.PriorPeriodData.IsPriorPeriodAdjustment &&
                    (!this.props.timecardPriorPeriodData || !this.props.timecardPriorPeriodData.DifferenceTimecard) && this.props.timecardExpense.PriorPeriodData.OriginalTimecardId &&
                    <div style={{ color: grey500, marginTop: 10, marginBottom: 5, paddingBottom: 10, borderBottom: "1px #666666 solid" }}>
                        <div style={{ fontSize: 11 }}>
                            <ExternalLink url={`/user-details/${this.props.user.Id}/timecards?referenceDate=${moment(this.props.timecardExpense.DateIncurred).format("MM/DD/YY")}`} fontSize={"11"} /> Prior Period Adjustment
                        </div>
                        <div style={{ marginLeft: 15 }}>
                            <div style={{ fontSize: 11 }}>
                                <div>Added to timecard by {this.props.timecardExpense.PriorPeriodData.ExportedBy}</div>
                                <div>{moment(this.props.timecardExpense.PriorPeriodData.ExportDateTime).format("MM/DD/YY h:mma")}</div>
                                {this.props.timecardExpense.PayrollExport &&

                                    <div>
                                        <div>
                                            <b>Payroll Exported: </b>{moment(this.props.timecardExpense.PayrollExport.ExportDate).format("MM/DD/YY h:mma")}
                                        </div>
                                        <div>
                                            Exported By: {this.props.timecardExpense.PayrollExport.ExportedByUserName}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                {this.props.timecardExpense.PriorPeriodData && this.props.timecardExpense.PriorPeriodData.IsPriorPeriodAdjustment && !this.props.timecardExpense.PriorPeriodData.OriginalTimecardId &&
                    <div style={{ color: grey500, marginTop: 10, marginBottom: 5, paddingBottom: 10, borderBottom: "1px #666666 solid" }}>
                        <div style={{ fontSize: 11 }}>
                            Prior Period Adjustment
                        </div>
                    </div>
                }

                {this.state.openAddExpenseDialog &&
                    <AddUserDetailExpenseDialog
                        loggedInUserType={ELoggedInUserType.AccountAdmin}
                        employee={this.props.user as IUserDocument}
                        payrollDataForPayGroup={this.props.payrollDataForPayGroup}
                        job={null}
                        payPeriodReferenceDate={moment().format()}
                        editExpense={this.props.timecardExpense}
                        handleClose={() => this.setState({ openAddExpenseDialog: false })}
                        handleAdd={expenseBundle => expenseActions.addExpense(this.props.user, expenseBundle, this.props.reloadTimecard)}
                        handleUpdate={expenseBundle => expenseActions.updateExpense(this.props.user, expenseBundle, this.props.reloadTimecard)}
                        showFrequencyControl={false}
                        frequency={0}
                        isOneTime={false}
                        payDate={null}
                        readonly={!canEditExpense || this.props.readonly}
                        timecard
                        payrollHierarchyId={this.props.payrollHierarchyId}
                        payrollPayGroupId={this.props.payrollPayGroupId}
                    />
                }
            </div>
        )
    }
}